import React from 'react';
import { useSelector } from 'react-redux';
import PublicApp from './publicApp';
// import FullApp from './fullApp';
const App = () => {
  const FullAppLoader = React.lazy(() => import('./fullAppLoader'));

  const { userToken, loginToken, portal } = useSelector(state => state.auth);
  const isUserLoggedIn = userToken || loginToken;
  const isPortalLoggedIn = portal?.token; // truthy if portal token exists

  if (!isUserLoggedIn && !isPortalLoggedIn) {
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <PublicApp />;
      </React.Suspense>
    );
  }

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <FullAppLoader />
    </React.Suspense>
  );
};

export default App;
